function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

function loadImageElement(imageUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.referrerPolicy = 'no-referrer';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Failed to load image'));
    image.src = imageUrl;
  });
}

function imageElementToBlob(image, format) {
  const normalizedFormat = format === 'jpeg' || format === 'jpg' ? 'jpeg' : 'png';
  const mimeType = normalizedFormat === 'jpeg' ? 'image/jpeg' : 'image/png';
  const canvas = document.createElement('canvas');
  canvas.width = image.naturalWidth || image.width;
  canvas.height = image.naturalHeight || image.height;
  const context = canvas.getContext('2d');
  if (!context) {
    return Promise.reject(new Error('Canvas not supported'));
  }
  if (normalizedFormat === 'jpeg') {
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
  }
  context.drawImage(image, 0, 0);
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('Failed to encode image'))),
      mimeType,
      normalizedFormat === 'jpeg' ? 0.92 : undefined,
    );
  });
}

/**
 * Download a render image as JPEG or PNG.
 * @param {string} imageUrl
 * @param {'jpeg' | 'jpg' | 'png'} format
 * @param {string} [filenameBase='render']
 */
export async function downloadRenderImageAs(imageUrl, format = 'png', filenameBase = 'render') {
  if (typeof imageUrl !== 'string' || !imageUrl.trim()) {
    throw new Error('No image URL');
  }
  const normalizedFormat = format === 'jpeg' || format === 'jpg' ? 'jpeg' : 'png';
  const extension = normalizedFormat === 'jpeg' ? 'jpg' : 'png';
  const image = await loadImageElement(imageUrl.trim());
  const blob = await imageElementToBlob(image, normalizedFormat);
  triggerBlobDownload(blob, `${filenameBase}-${Date.now()}.${extension}`);
}
